import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RenderConfigurationService } from 'render/services/render-configuration.service';


@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {

  constructor(
    private readonly renderConfigurationService: RenderConfigurationService
  ) {}

  public intercept<T = Record<string, unknown>>(request: HttpRequest<T>,next: HttpHandler): Observable<HttpEvent<T>> {
    const hasCredentials = !this.renderConfigurationService.config.ignoreCredentials;
    return next.handle(request.clone({ withCredentials: hasCredentials }));
  }

}
